export const SELECT_EVENT = 'SELECT_EVENT';

export function selectEvent(event) {
    return {
        type: SELECT_EVENT,
        event,
    };
}
